import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * SPDX-FileCopyrightText: 2024 Genome Research Ltd.
 *
 * SPDX-License-Identifier: MIT
 */
import Modal from "../general/Modal";
import { Button } from "../index";
function ConfirmationModal(props) {
    const { setOpen, open, onConfirmClick, itemType } = props;
    const actionButtons = (_jsxs("div", { style: { paddingBottom: "35px" }, children: [_jsx(Button, { position: "right", type: "success", onClick: () => {
                    setOpen(false), onConfirmClick();
                }, text: "Confirm" }), _jsx(Button, { position: "right", type: "error", onClick: () => setOpen(false), text: "Cancel" })] }));
    const header = (_jsx("div", { children: _jsx("h4", { children: "Confirm Deletion" }) }));
    const body = (_jsxs("div", { children: [_jsxs("p", { style: { marginBottom: "-6px" }, children: ["Are you sure you want to delete this ", itemType ?? "item", "?"] }), _jsxs("p", { style: { color: "#d62915" }, children: ["Warning: If you delete this ", itemType ?? "item", ", you will not be able to retrieve it later."] })] }));
    return (_jsx("div", { className: "confirm-delete-buttons", children: _jsx(Modal, { setOpen: setOpen, open: open, size: "sm", children: body, closeButton: false, header: header, actionButton: actionButtons }) }));
}
export default ConfirmationModal;
